<template>
  <div class="subtitle d-inline-flex align-items-center">
    <span
      @click="scrollLeft"
      v-if="!printView"
      class="subtitle__scroll-button fa fa-caret-left"
    />
    <div
      v-if="!printView"
      class="subtitle__content d-inline-flex align-items-center mx-2"
      ref="subtitleContainer"
    >
      <div
        v-for="(value, index) in value"
        :key="index"
        class="d-inline-flex align-items-center mx-2"
      >
        <span
          class="subtitle__item-icon pr-2 fa fa-circle"
          :style="`color: ${value.color};`"
        />
        <span>
          {{ value.name }}
        </span>
      </div>
    </div>
    <div
      v-else
      class="subtitle__content-print d-inline-flex align-items-center mx-2"
      ref="subtitleContainer"
      >
      <div
        v-for="(value, index) in value"
        :key="index"
        class="d-inline-flex align-items-center mx-2"
      >
        <span
          class="subtitle__item-icon pr-2 fa fa-circle"
          :style="`color: ${value.color};`"
        />
        <span>
          {{ value.name }}
        </span>
      </div>
    </div>
    <span
      v-if="!printView"
      class="subtitle__scroll-button fa fa-caret-right"
      @click="scrollRight"
    />
  </div>
</template>
<style lang="sass" scoped>
.subtitle
  max-width: 350px
  &__content
    overflow-x: hidden
  &__content-print
    display: flex
    justify-content: center
    align-items: center
    flex-wrap: wrap
  &__item-icon
    font-size: .6em
  &__scroll-button
    font-size: 1.8em
    cursor: pointer
    color: var(--font-color-secondary)
</style>
<script>

const SCROLL_SIZE = 60;

export default {
  props: {
    /**
     * Dados dos pontos no gráfico.
     * @type {Object[]}
     * @property {String} name Nome.
     * @property {String} color Cor do ponto.
     */
    value: {
      type: Array,
    },
    printView: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    scrollData: {},
  }),
  methods: {
    scrollRight() {
      this.scrollHorizontal(SCROLL_SIZE);
    },
    scrollLeft() {
      this.scrollHorizontal(-SCROLL_SIZE);
    },
    scrollHorizontal(amount) {
      try {
        /**
         * O Edge não suporta scrollBy, então usando o try..catch com uma solução alternativa.
         * Porém, a solução empregada no catch é um scroll abrupto, sem animação.
         *
         * Esta limitação deve desaparecer se o Edge migrar para o Chromium (@see https://support.microsoft.com/pt-br/help/4501095/download-microsoft-edge-based-on-chromium)
         */
        this.$refs.subtitleContainer.scrollBy({
          top: 0,
          left: amount,
          behavior: 'smooth',
        });
      } catch {
        this.$refs.subtitleContainer.scrollLeft += amount;
      }
    },
  },
};
</script>
